import { render, staticRenderFns } from "./headNav.vue?vue&type=template&id=4a1bff5c&scoped=true&"
import script from "./headNav.vue?vue&type=script&lang=js&"
export * from "./headNav.vue?vue&type=script&lang=js&"
import style0 from "./headNav.vue?vue&type=style&index=0&id=4a1bff5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1bff5c",
  null
  
)

export default component.exports